export default function MRReportInstancesController() { /* provided only for controllerAs binding */ }
